import {Component, OnDestroy, OnInit} from '@angular/core';
import {GOOGLEADS} from '../../../shared/components/template-slot/template-slot.component';
import {Router} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {SocialTagsService} from '../../../core/services/social-tags-service.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss']
})
export class CalculatorComponent implements OnInit {

  result: any = null;
  googleAds = GOOGLEADS;

  readonly tagSocialTitle: string = 'โปรแกรมคำนวณภาษีหัก ณ ที่จ่าย และภาษีมูลค่าเพิ่ม (VAT)';
  readonly tagSocialDescription: string = 'คำนวณภาษีหัก ณ ที่จ่าย และภาษีมูลค่าเพิ่ม (VAT 7%) ออนไลน์ ไม่ต้องเสียเวลาคิดใน Excel';
  readonly urlPrefix: string = environment.mainBaseUrl;

  constructor(
    private router: Router,
    private meta: Meta,
    private title: Title,
    private tagsService: SocialTagsService
  ) {
    this.title.setTitle('โปรแกรมคำนวณภาษีหัก ณ ที่จ่าย และภาษีมูลค่าเพิ่ม (VAT) - iTAX');
    this.meta.updateTag({
      name: 'title',
      content: 'โปรแกรมคำนวณภาษีหัก ณ ที่จ่าย และภาษีมูลค่าเพิ่ม (VAT) - iTAX'
    });
    this.meta.updateTag({
      name: 'description',
      content: 'โปรแกรมช่วยคำนวณภาษีหัก ณ ที่จ่าย และภาษีมูลค่าเพิ่ม (VAT 7%) แบบออนไลน์ ไม่ต้องเสียเวลาคิดใน Excel เหมาะสำหรับฟรีแลนซ์ นักบัญชี ทดลองใช้ได้ที่ iTAX'
    });
    this.tagsService.setTitleAndTags({
      tagSocialDescription: this.tagSocialDescription,
      tagSocialTitle: this.tagSocialTitle,
      urlPrefix: this.urlPrefix
    });
  }

  ngOnInit(): void {
  }

  onCalChange(item): any {
    this.result = item;
    const fm = Object.keys(item).filter(key => key !== 'payment').map(key => key + '=' + item[key]).join('&');
    this.router.navigate(['./vat-result'], {fragment: fm, state: item.payment});
  }

}
